import { Injectable } from '@angular/core';
import { ApiService, Promotion } from '@us/web/shared/data-access';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PromotionsService {
    constructor(private apiService: ApiService) {}

    public getPromotions(params?: any): Observable<Promotion[]> {
        return this.apiService.get('shop/promotions', { params: params }).pipe(map(response => response));
    }
}
